import { Page } from './pages';

import { PATH } from '../../constants';

export default {
  component: Page,
  name: 'Perfomance Analysis',
  path: PATH.ANALYZE
};
